import { useState } from 'react'
import { Accordion, Button, Flex, Box, Text } from 'src/componentv2'
import apkIcon from 'src/assets/v2/img/apk_icon.svg'

type BuildStatus = 'idle' | 'generating' | 'ready'

interface GeneratedBuild {
    date: string
}

export const AppGeneration: React.FC<{ open: boolean; onToggle: (o: boolean) => void }> = ({ open, onToggle }) => {
    const [status, setStatus] = useState<BuildStatus>('idle')
    const [build, setBuild] = useState<GeneratedBuild | null>(null)

    const handleGenerate = () => {
        setStatus('generating')
        setTimeout(() => {
            setStatus('ready')
            setBuild({
                date: new Date().toLocaleString('en-GB', {
                    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
                }).replace(',', ''),
            })
        }, 2500)
    }

    return (
        <Accordion title="App Generation" subtitle="Live" open={open} onToggle={onToggle}>
            <Flex justify="center">
                <Box width="45rem">
                    <Button
                        variant="primary"
                        size="md"
                        block
                        disabled={status === 'generating'}
                        onClick={handleGenerate}
                    >
                        {status === 'generating' ? 'Generating build…' : 'Generate APK build'}
                    </Button>

                    {status === 'generating' && (
                        <Box topMargin="1.6" className="business-logic__build-banner">
                            <Text fontSize="1.4" color="#0D968F">
                                A build is currently in progress, kindly check back later
                            </Text>
                        </Box>
                    )}

                    {status === 'ready' && build && (
                        <Box topMargin="1.6" className="business-logic__build-card">
                            <img src={apkIcon} alt="" width={40} height={40} />
                            <Text fontSize="1.4" color="#667085" topMargin="1.2">
                                Generated on {build.date}
                            </Text>
                            <a className="business-logic__download-link" href="#" onClick={(e) => e.preventDefault()}>
                                Click to Download
                            </a>
                        </Box>
                    )}
                </Box>
            </Flex>
        </Accordion>
    )
}

export default AppGeneration